import commonApi from "@/api/common.api.js";
import { $DKD } from '@/conf/common.const.js';

export default {
    state: {
        promiseInfo: {},
        relevantBizList: [],
        governanceFoundList: [],
        governanceInnoList: [],
    },
    getters: {
        getPromiseInfo(state) {
            return state.promiseInfo;
        },
        getRelevantBizList(state) {
            return state.relevantBizList;
        },
        getGovernanceFoundList(state) {
            return state.governanceFoundList;
        },
        getGovernanceInnoList(state) {
            return state.governanceInnoList;
        },
    },
    mutations: {
        SET_PROMISE_INFO(state, promiseInfo) {
            state.promiseInfo = promiseInfo;
        },
        SET_FETCH_RELEVANT_BIZ_LIST(state, relevantBizList) {
            state.relevantBizList = relevantBizList;
        },
        SET_GOVERNANCE_FOUND_LIST(state, governanceFoundList) {
            state.governanceFoundList = governanceFoundList;
        },
        SET_GOVERNANCE_INNO_LIST(state, governanceInnoList) {
            state.governanceInnoList = governanceInnoList;
        },
    },
    actions : {
        FETCH_PROMISE_INFO({commit}, paramObj) {
            return commonApi.fetchRepoData(paramObj.dataKdSqno, paramObj.dataSqno, true)
                .then((res) => {
                    commit('SET_PROMISE_INFO', res.data.data);
                })
        },
        FETCH_RELEVANT_BIZ_LIST({commit}, paramObj) {
            var q = "val9=" + paramObj.val9;
            return commonApi.fetchRepoDataList(paramObj.dataKdSqno, q)
                .then((res) => {
                    commit('SET_FETCH_RELEVANT_BIZ_LIST', res.data.data);
                })
        },
        FETCH_GOVERNANCE_FOUND_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.GOVERNANCE_FOUND)
                .then((res) => {
                    commit('SET_GOVERNANCE_FOUND_LIST', res.data.data);
                })
        },
        FETCH_GOVERNANCE_INNO_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.GOVERNANCE_INNO)
                .then((res) => {
                    commit('SET_GOVERNANCE_INNO_LIST', res.data.data);
                })
        },
    }
};
